// extracted by mini-css-extract-plugin
module.exports = {"goTopButton":"GoTopButton_goTopButton__LoKux"};